import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function RenouvellementAbonnement({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Vous êtes abonné depuis plusieurs années à notre magazine{" "}
        {variablesData.la_vie_francaise_directeur_general_societe}.
      </p>
      <p>
        Votre abonnement arrive à échéance et nous espérons avoir le plaisir de
        vous garder parmi nos clients fidèles.
      </p>
      <p>
        Qui, mieux que{" "}
        {variablesData.la_vie_francaise_directeur_general_societe}, saura vous
        relater l'actualité économique, politique et les évènements majeurs de
        notre Société en mouvement perpétuel avec l'ouverture, le sérieux et la
        rigueur dont notre journal apporte la preuve depuis maintenant plus de
        60 ans.
      </p>
      <p>
        Nous vous remercions, par avance, pour votre confiance renouvelée et
        nous vous prions de croire, Monsieur, en l'expression de notre
        considération distinguée.
      </p>
      <p className="pt-10 text-center font-bold underline">
        Conditions particulières réservées aux clients privilégiés
      </p>
      <p className="text-center font-bold">
        {variablesData.la_vie_francaise_directeur_general_societe} - 12 numéros
        par an <span className="underline">au prix de 160 euros</span>
      </p>
      <p className="text-center font-bold">
        (au lieu de 240 euros - prix public -)
      </p>
      <MailSignature
        emetteurLogo={RenouvellementAbonnement.metadata.emetteurLogo}
        emetteur={RenouvellementAbonnement.metadata.emetteur}
        emetteurPoste={RenouvellementAbonnement.metadata.emetteurPoste}
        emetteurEntreprise={
          RenouvellementAbonnement.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

RenouvellementAbonnement.metadata = {
  titre: "Renouvellement d'abonnement",
  cleMail: "renouvellement_abonnement",
  messageTransfert: false,
  emetteur: "Gilbert THEVENOT",
  emetteurPoste: "Directeur Général",
  emetteurEntreprise: "LA VIE FRANCAISE",
  emetteurLogo: null,
  dateRelative: -4,
  piecesJointes: [],
} as MailMetadata;

export default RenouvellementAbonnement;
